import { z } from "zod";
import { FlightOfferStatus } from "../enums.js";
import { isoDateTimeSchema, uuidSchema } from "./common.js";
const baseFlightOfferFields = {
    aircraftId: uuidSchema.optional().nullable(),
    aircraftRegistrationText: z.string().trim().min(1).max(20).optional().nullable(),
    aircraftTypeId: uuidSchema.optional().nullable(),
    startAt: isoDateTimeSchema,
    endAt: isoDateTimeSchema,
    fromLocation: z.string().trim().min(1).max(80),
    toLocation: z.string().trim().min(1).max(80),
    freeSeats: z.coerce.number().int().min(1).max(20).default(1),
    sharedPic: z.coerce.boolean().default(false),
    favoritesOnly: z.coerce.boolean().default(false),
    roundTrip: z.coerce.boolean().default(false),
    costShareText: z.string().trim().max(200).optional().nullable(),
    comment: z.string().trim().max(500).optional().nullable(),
    eventId: uuidSchema.optional().nullable(),
};
export const createFlightOfferSchema = z
    .object(baseFlightOfferFields)
    .superRefine((data, ctx) => {
    if (!data.aircraftId && !data.aircraftRegistrationText) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["aircraftId"],
            message: "Entweder ein Flugzeug aus der Liste wählen oder eine Kennung als Freitext angeben",
        });
    }
    if (new Date(data.endAt) <= new Date(data.startAt)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["endAt"],
            message: "Endzeit muss nach Startzeit liegen",
        });
    }
});
export const updateFlightOfferSchema = z
    .object({
    aircraftId: baseFlightOfferFields.aircraftId,
    aircraftRegistrationText: baseFlightOfferFields.aircraftRegistrationText,
    aircraftTypeId: baseFlightOfferFields.aircraftTypeId,
    startAt: isoDateTimeSchema.optional(),
    endAt: isoDateTimeSchema.optional(),
    fromLocation: baseFlightOfferFields.fromLocation.optional(),
    toLocation: baseFlightOfferFields.toLocation.optional(),
    freeSeats: baseFlightOfferFields.freeSeats.optional(),
    sharedPic: baseFlightOfferFields.sharedPic.optional(),
    favoritesOnly: baseFlightOfferFields.favoritesOnly.optional(),
    roundTrip: baseFlightOfferFields.roundTrip.optional(),
    costShareText: baseFlightOfferFields.costShareText,
    comment: baseFlightOfferFields.comment,
    eventId: baseFlightOfferFields.eventId,
})
    .superRefine((data, ctx) => {
    if (data.startAt && data.endAt && new Date(data.endAt) <= new Date(data.startAt)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["endAt"],
            message: "Endzeit muss nach Startzeit liegen",
        });
    }
});
export const cancelFlightOfferSchema = z.object({
    reason: z.string().trim().max(500).optional().nullable(),
});
export const adminDeactivateFlightSchema = z.object({
    reason: z.string().trim().min(1, "Grund ist Pflichtfeld").max(500),
});
export const flightListQuerySchema = z.object({
    aircraftTypeId: uuidSchema.optional(),
    fromDate: isoDateTimeSchema.optional(),
    toDate: isoDateTimeSchema.optional(),
    fromLocation: z.string().trim().max(80).optional(),
    onlyAvailable: z.coerce.boolean().default(true),
    status: z.nativeEnum(FlightOfferStatus).optional(),
});
//# sourceMappingURL=flight-offer.js.map